export const GET_SHORTCUTS = "[SHORTCUTS] GET SHORTCUTS";
export const SET_SHORTCUTS = "[SHORTCUTS] SET SHORTCUTS";

export function setShortcuts(payload) {
  return {
    type: SET_SHORTCUTS,
    payload,
  };
}
